
// PATHS
import axios from "axios";
import { replaceObjectsInUrls } from "../utils";

const FIND_GENERAL_TIMEFRAME = 'network/repair-shop/timeframe/findGeneralTimes/{id}';
const FIND_SPECIFIC_TIMEFRAME = 'network/repair-shop/timeframe/findSpecificTimes/{id}';
const FIND_OPEN_CLOSE_TIMEFRAME = 'network/timeframe/findTimeFrame';
const CREATE_SPECIFIC_TIMEFRAME = 'network/repair-shop/timeframe/createSpecificTimes';
const CREATE_GENERAL_TIMEFRAME = 'network/repair-shop/timeframe/createGeneralTimes';
const CHECK_ACTIVATION = 'network/ms/activation';
const GET_GENERAL_DATA_ACTIVATION = 'network/ms/findActivationDetail';
const SAVE_BOOKABILITY_VISIBILITY = 'network/bookAbilityVisibility/create';

/*
(replaceObjectsInUrls(GET_RS_BY_ID, req))
*/

const findGeneralTimeframe: any = async (req: any) => {
    const response = await axios.get(replaceObjectsInUrls(FIND_GENERAL_TIMEFRAME, req));
    return response.data;
}

const findSpecificTimeframe: any = async (req: any) => {
    const response = await axios.get(replaceObjectsInUrls(FIND_SPECIFIC_TIMEFRAME, req));
    return response.data;
}

const findOpenCloseTimeframe: any = async (req: any) => {
    const response = await axios.post(FIND_OPEN_CLOSE_TIMEFRAME, req);
    return response.data;
}

const createGeneralTimeframe: any = async (req: any) => {
    const response = await axios.post(CREATE_GENERAL_TIMEFRAME, req);
    return response.data;
}

const createSpecificTimeframe: any = async (req: any) => {
    const response = await axios.post(CREATE_SPECIFIC_TIMEFRAME, req);
    return response.data;
}

const checkInfoActivation: any = async (req: any) => {
    const response = await axios.post(CHECK_ACTIVATION, req);
    return response.data;
}

const getGeneralDataActivation: any = async (req: any) => {
    const response = await axios.post(GET_GENERAL_DATA_ACTIVATION, req);
    return response.data;
}

const saveBookabilityVisibility: any = async (req: any) => {
    const response = await axios.post(SAVE_BOOKABILITY_VISIBILITY, req);
    return response.data;
}
export {
    findGeneralTimeframe,
    findSpecificTimeframe,
    findOpenCloseTimeframe,
    createSpecificTimeframe,
    createGeneralTimeframe,
    checkInfoActivation,
    getGeneralDataActivation,
    saveBookabilityVisibility
}